import React, { useContext, useEffect, useMemo, useState } from "react";
import AllStateContext from "../context/allstateContext";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FILTER_TYPE } from "../Constant/constant";

const AddNewCategoryDialog = ({ refetch }) => {
  const {
    openMonthFilterDialog,
    setOpenMonthFilterDialog,
    selectedFilterType,
    setSelectedFilterType,
    setResetFilter,
  } = useContext(AllStateContext);

  useMemo(() => {}, []);

  const handleClose = () => {
    setOpenMonthFilterDialog(false);
  };

  const handleSave = async () => {
    setResetFilter(true);
    setOpenMonthFilterDialog(false);
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={openMonthFilterDialog}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: "var(--bg-secondary)",
            color: "var(--text-primary)",
            borderRadius: "20px",
            border: "1px solid var(--border-color)",
            boxShadow: "var(--glass-shadow)"
          }
        }}
      >
        <div style={{ padding: "32px 28px 24px" }}>
          <h4 style={{ 
            fontWeight: 800, 
            margin: "0 0 12px 0",
            fontSize: "1.4rem",
            letterSpacing: "-0.01em",
            color: "var(--text-primary)"
          }}>
            Date Filter
          </h4>
          <p style={{ 
            fontSize: "0.95rem", 
            color: "var(--text-secondary)", 
            lineHeight: 1.5,
            margin: "0 0 24px 0"
          }}>
            Select the time range to view your transactions.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {[
              { type: FILTER_TYPE.MONTHLY, label: "Monthly View" },
              { type: FILTER_TYPE.MONTH_3, label: "3 Months View" },
              { type: FILTER_TYPE.MONTH_6, label: "6 Months View" },
              { type: FILTER_TYPE.YEARLY, label: "Yearly View" }
            ].map((option) => (
              <button
                key={option.type}
                onClick={() => setSelectedFilterType(option.type)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "100%",
                  padding: "16px",
                  borderRadius: "12px",
                  border: `1px solid ${selectedFilterType === option.type ? "var(--primary)" : "var(--border-color)"}`,
                  backgroundColor: selectedFilterType === option.type ? "var(--primary-glow)" : "var(--bg-surface)",
                  color: selectedFilterType === option.type ? "var(--primary)" : "var(--text-primary)",
                  fontWeight: 600,
                  fontSize: "1rem",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
              >
                <div style={{ 
                  marginRight: "16px", 
                  display: "flex", 
                  alignItems: "center", 
                  justifyContent: "center",
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: `2px solid ${selectedFilterType === option.type ? "var(--primary)" : "var(--text-secondary)"}`,
                  backgroundColor: selectedFilterType === option.type ? "var(--primary)" : "transparent",
                  color: "#fff",
                  fontSize: "12px",
                  opacity: selectedFilterType === option.type ? 1 : 0.5
                }}>
                  {selectedFilterType === option.type && "✓"}
                </div>
                <span>
                  {option.label}
                </span>
              </button>
            ))}
          </div>

          <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "32px" }}>
            <button 
              onClick={handleClose} 
              style={{
                backgroundColor: "transparent",
                color: "var(--text-secondary)",
                border: "none",
                fontWeight: 700,
                fontSize: "0.95rem",
                padding: "10px 20px",
                borderRadius: "10px",
                cursor: "pointer",
                transition: "color 0.2s, background-color 0.2s"
              }}
              onMouseEnter={(e) => (e.target.style.color = "var(--text-primary)", e.target.style.backgroundColor = "var(--bg-surface-hover)")}
              onMouseLeave={(e) => (e.target.style.color = "var(--text-secondary)", e.target.style.backgroundColor = "transparent")}
            >
              Cancel
            </button>
            <button 
              onClick={handleSave} 
              style={{
                backgroundColor: "var(--primary)",
                color: "#fff",
                border: "none",
                fontWeight: 700,
                fontSize: "0.95rem",
                padding: "10px 24px",
                borderRadius: "10px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.1s, opacity 0.2s",
                boxShadow: "0 4px 12px var(--primary-glow)"
              }}
              onMouseDown={(e) => (e.target.style.transform = "scale(0.97)")}
              onMouseUp={(e) => (e.target.style.transform = "scale(1)")}
              onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default AddNewCategoryDialog;
